import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Path } from '../helpers/enum';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  constructor(
    private router: Router,
    private location: Location,
  ) {}

  goToChatListing(){
    this.route(Path.chatListing,true,);
  }

  goBack() {
    this.location.back();
  }

  goToEditPlan(data:any) {
    this.route(Path.addPlan, true, data);
  }

  goToAddPlan() {
    this.route(Path.addPlan, true,);
  }


  goToDetailLocation(data:any){
    this.route(Path.detailLocation, true, data);
  }

  goToDetailComplaints(data:any){
    this.route(Path.detailComplaint, true, data);
  }

  goToDetailChatManagement(data:any){
    this.route(Path.detailChatManagment, true, data);
  }

  goToDetailComboBooking(data:any){
    this.route(Path.detailComboBooking, true, data);
  }

  goToDetailListingComboBooking(){
    this.route(Path.listingComboBooking, true);
  }

  goToDetailRefundManagement(data:any){
    this.route(Path.detailRefundManagment, true, data);
  }

  goToDetailCustomer(data:any){
    this.route(Path.detailCustomer, true, data);
  }

  goToComboPackage(data:any){
    this.route(Path.detailComboPackage, true, data);
  }

  goToEditComboPackage(data:any) {
    this.route(Path.editComboPackage, true, data);
  }

  goToEditService(data:any) {
    this.route(Path.editService, true, data);
  }

  goToDetailService(data:any) {
    this.route(Path.detailService, true, data);
  }

  goToBookingDetail(data:any) {
    this.route(Path.detailBooking, true, data);
  }

  goToAddCoupons() {
    this.route(Path.addCoupons, true,);
  }

  goToDetailCoupons(data:any) {
    this.route(Path.detailCoupons, true, data);
  }

  goToEditCoupons(data:any) {
    this.route(Path.addCoupons, true, data);
  }

  dynamicPath(path: string, params: string = '') {
    if (params) {
      this.route(path, false, { id: params });
    } else {
      this.route(path);
    }
  }

  route(path: string, replaceUrl: boolean = false, data?: any) {
    if (!data) {
      this.router.navigate([path], { replaceUrl });
    } else {
      this.router.navigate([path], {
        replaceUrl,
        queryParams: data,
      });
    }
  }

}
